import { EErrorCode } from 'config/errors-codes';
import { errorCollection } from 'config/ui/error-collection';
import { showToast } from 'state/toast';
import { ApiError } from 'utils/errors';
export interface ICustomerFacingErrorOptions {
  message?: string;
  title?: string;
}
export class CustomerFacingError extends Error {
  code: EErrorCode;
  title: string;
  constructor(code: EErrorCode, options?: ICustomerFacingErrorOptions) {
    const message = options?.message || errorCollection[code]?.message().id || '';
    super(message);
    this.name = 'CustomerFacingError';
    this.code = code;
    this.title = options?.title || errorCollection[code]?.title().id || '';
    window?.E3D?.reportError(this);
  }
}

/** Show the catalog error toast for `code` — catalog copy only, never a raw error message (AVS-4505). */
export function showErrorToast(code: EErrorCode): void {
  const details = errorCollection[code] ?? errorCollection[EErrorCode.INTERNAL_ERROR];
  showToast({
    title: details.title(),
    message: details.message(),
    type: 'error',
    notificationId: details.notificationId,
  });
}

/**
 * Toast a failure the API client left silent. sendApiRequest already toasted any other ApiError,
 * so only a non-ApiError or a transport-level INTERNAL_ERROR needs one here.
 */
export function reportUntoastedApiFailure(error: unknown): void {
  if (!(error instanceof ApiError) || error.code === EErrorCode.INTERNAL_ERROR) {
    showErrorToast(EErrorCode.INTERNAL_ERROR);
  }
}
